export const alternateClassMixin = {
    methods: {
        alternateClass(): string {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (this as any).index % 2 ? "even" : "odd";
        },
    },
};
